import { Context, createContext, FC } from 'react';
import { useQuery } from 'react-query';
import { Contract, ContractBuildType } from 'cmp-client-api';

import { ProviderPropsInterface } from '@src/core/auth/components/types/provider-props.interface';
import { useInjectableServices } from '@src/server/service-registry.provider';

export interface SupportPrefetchContextInterface {
  serviceOptions: Contract[];
  isFetchingServices: boolean;
  isFetchedAfterMount: boolean;
}

export const SupportPrefetchContext: Context<SupportPrefetchContextInterface> = createContext({
  serviceOptions: [],
  isFetchingServices: true,
  isFetchedAfterMount: false,
});

export interface SupportPrefetchContextPropsInterface {}

const FIVE_MINUTES = 60 * 1000 * 5;

export const SupportPrefetchContextProvider: FC<
  ProviderPropsInterface & SupportPrefetchContextPropsInterface
> = (props) => {
  const { children } = props;

  const { SupportSystemService } = useInjectableServices();

  const {
    data: serviceOptions = [],
    isFetching: isFetchingServices,
    isFetchedAfterMount,
  } = useQuery(
    ['fetch-services'],
    // ITSM is not supported, but the API still lists ITSM contracts.
    async () =>
      (await SupportSystemService.listServices()).filter(
        ({ buildType }) => buildType === ContractBuildType.CSM
      ),
    { staleTime: FIVE_MINUTES }
  );

  return (
    <SupportPrefetchContext.Provider
      value={{
        serviceOptions,
        isFetchingServices,
        isFetchedAfterMount,
      }}
    >
      {children}
    </SupportPrefetchContext.Provider>
  );
};
